/**
 * Email confirmation validator
 * Validates that email and email confirmation fields match
 */

class EmailConfirmationValidator {
  constructor(formSelector) {
    this.form = document.querySelector(formSelector);
    if (!this.form) return;

    this.emailInput = this.form.querySelector(`input[type="email"][data-email]`);
    this.confirmEmailInput = this.form.querySelector(`input[type="email"][data-email-confirmation]`);
    this.errorMessage = this.confirmEmailInput.getAttribute('data-error-message');
    
    if (this.emailInput && this.confirmEmailInput) {
      this.init();
    }
  }

  init() {
    // Add event listeners for real-time validation
    this.confirmEmailInput.addEventListener('input', () => this.validateMatch());
    this.confirmEmailInput.addEventListener('blur', () => this.validateMatch());
    
    // Validate on form submit
    this.form.addEventListener('submit', (e) => {
      if (!this.validateMatch()) {
        e.preventDefault();
        this.confirmEmailInput.focus();
      }
    });
  }

  validateMatch() {
    const email = this.emailInput.value.trim();
    const confirmEmail = this.confirmEmailInput.value.trim();
    
    if (confirmEmail && email !== confirmEmail) {
      this.showError();
      return false;
    } else {
      this.clearError();
      return true;
    }
  }

  showError() {
    this.confirmEmailInput.setCustomValidity(this.errorMessage);
    this.confirmEmailInput.classList.add('error');
  }

  clearError() {
    this.confirmEmailInput.setCustomValidity('');
    this.confirmEmailInput.classList.remove('error');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new EmailConfirmationValidator('.gift-card__form-wrap');
});